<script>
	import Basket from '../../Classes/Basket';
	import Config from '../../Config';
	import Gallery from '../../Stores/Gallery';
	import Helper from '../../Classes/Helper';
	import Layout from '../../Stores/Layout';
	import Menu from '../../Stores/Menu';
	import Note from '../Widgets/Note.svelte';
	import Group from '../../Classes/Group';
	import Product from '../../Stores/Product';
	import Registry from '../../Stores/Registry';

	let loading = false;
	let success = false;
	let error = false;

	const notes = {
		loading: {
			icon: 'fa-duotone fa-spinner fa-spin',
			title: 'Een moment geduld...',
			description: `Uw <b>${$Product.make} ${$Product.name}</b> wordt aan het winkelmandje toegevoegd.`
		},
		success: {
			success: true,
			icon: 'fa-duotone fa-party-horn',
			title: 'Toegevoegd aan het winkelmandje!',
			description: `Uw <b>${$Product.make} ${$Product.name}</b> is aan het winkelmandje toegevoegd.`
		},
		error: {
			icon: 'fa-duotone fa-circle-exclamation',
			title: 'Er gaat iets mis.',
			description: `Uw <b>${$Product.make} ${$Product.name}</b> kan niet aan het winkelmandje worden toegevoegd.`
		}
	};

	function edit(step, property) {
		Product.setStep(step.order);
		Product.setProperty(property);
		Layout.product();
	}

	async function basket() {
		loading = true;
		const group = new Group();
		let proceed = await group.post();
		if (proceed) {
			const basket = new Basket();
			proceed = await basket.post();
		}

		success = !!proceed;
		error = !success;
		loading = false;

		if (success) {
			const basket = Config.shop.basket;
			window.location.href = Registry.shopUrl(basket);
		}
	}
</script>

<style>
	div.zes-step {
		display: flex;
		gap: 1.5em;
		margin-bottom: 1.5em;
	}

	div.zes-number {
		font-size: 1.75em;
		color: var(--zes-1-2);
	}

	div.zes-success div.zes-number {
		color: var(--zes-2-2);
	}

	div.zes-error div.zes-number {
		color: var(--zes-4-2);
	}

	div.zes-content {
		flex-grow: 1;
	}

	div.zes-title {
		font-size: 1.1em;
		font-weight: 600;
		text-transform: uppercase;
		color: var(--zes-1-1);
		padding-bottom: .25em;
		margin: .3em 0 .5em 0;
		border-bottom: 2px solid hsl(206deg 75% 25% / .25);
	}

	div.zes-success div.zes-title {
		font-weight: 700;
		color: var(--zes-2-1);
		border-bottom-color: hsl(95deg 70% 30% / .4);
	}

	div.zes-error div.zes-title {
		color: var(--zes-4-1);
		border-bottom-color: hsl(0deg 70% 30% / .4);
	}

	div.zes-group {
		font-size: .95em;
		font-weight: 600;
		display: flex;
		align-items: baseline;
		gap: 1em;
		padding: .25em 0;
		margin-bottom: .25em;
		border-bottom: 1px solid hsl(206deg 75% 85% / .5);
	}

	div.zes-key {
		font-size: .8em;
		color: var(--zes-3-1);
		width: 10em;
	}

	div.zes-success div.zes-key {
		color: var(--zes-2-2);
	}

	div.zes-error > div.zes-key {
		color: var(--zes-4-2);
	}

	div.zes-edit {
		color: var(--zes-1-3);
		cursor: pointer;
	}

	div.zes-edit:hover {
		color: var(--zes-1-1);
	}

	div.zes-error > div.zes-edit {
		color: var(--zes-4-3);
	}

	div.zes-error > div.zes-edit:hover {
		color: var(--zes-4-1);
	}

	div.zes-value {
		color: var(--zes-1-2);
		flex-grow: 1;
	}

	div.zes-success div.zes-value {
		color: var(--zes-2-1);
	}

	div.zes-error > div.zes-value {
		color: var(--zes-4-1);
	}

	div.zes-success div.zes-group:last-child div.zes-value {
		font-size: 1.25em;
		font-weight: 700;
	}

	div.zes-price {
		letter-spacing: -.025em;
		min-width: 5em;
		text-align: right;
	}

	div.zes-success div.zes-group:last-child div.zes-price {
		font-size: 1.25em;
		font-weight: 700;
	}

	div.zes-success div.zes-price {
		color: var(--zes-2-1);
	}

	div.zes-error > div.zes-price {
		color: var(--zes-4-1);
	}

	/* Toolbar */

	div.zes-toolbar {
		display: flex;
		justify-content: flex-end;
		align-items: flex-end;
		gap: .5em;
		margin-bottom: 3.5em;
	}

	.zes-button {
		font-size: .65em;
		font-weight: 600;
		text-align: center;
		text-transform: uppercase;
		text-decoration: none;
		color: #FFF;
		padding: .5em 1.5em;
		border-radius: .35em;
		background: var(--zes-1-2);
		cursor: pointer;
		display: block;
	}

	.zes-button:hover {
		text-decoration: none;
		background: var(--zes-1-1);
	}

	.zes-button.zes-button-large {
		font-size: 1.25em;
		margin-left: 1em;
	}

	.zes-button.zes-button-large i {
		margin-left: .25em;
	}

	.zes-button:not(.zes-button-large) i {
		margin-right: .5em;
	}

	.zes-button.zes-success {
		background: var(--zes-2-2);
	}

	.zes-button.zes-success:hover {
		background: var(--zes-2-1);
	}

	.zes-button.zes-disabled {
		cursor: auto;
		background: var(--zes-3-2);
	}

	.zes-button.zes-disabled:hover {
		background: var(--zes-3-1);
	}

	/* Images */

	div.zes-images img {
		border-radius: .5em;
		margin-bottom: 1em;
	}

	div.zes-images h4 {
		font-size: 1.1em;
		font-weight: 600;
		text-transform: uppercase;
		color: var(--zes-1-1);
		padding-bottom: .5em;
		margin-top: 3em;
		border-bottom: 2px solid hsl(206deg 75% 25% / .25);
	}

	div.zes-images h4 i {
		font-size: 1.75rem;
		color: var(--zes-1-2);
		margin-right: .75em;
	}

	/* Proceed */

	div.zes-proceed .zes-button {
		margin-left: 0;
		margin-bottom: .75em;
	}

	div.zes-proceed .zes-button:not(.zes-button-large) {
		font-size: .9em;
	}

	/* Responsive */

	@media only screen and (max-width: 1024px) and (orientation: portrait) {
		.zes-button i {
			display: none;
		}

		div.zes-toolbar {
			flex-direction: column;
			align-items: stretch;
		}

		div.zes-toolbar .zes-button {
			margin-left: 2.75rem;
		}
	}
</style>

{#if !loading && error}
	<Note config="{notes.error}"/>
{:else if loading}
	<Note config="{notes.loading}"/>
{:else}
	<div class="zes-quotation">
		<div class="zes-step zes-success">
			<div class="zes-number">
				<i class="fa-solid fa-circle-info"></i>
			</div>
			<div class="zes-content">
				<div class="zes-title">Offerte</div>
				<div class="zes-group">
					<div class="zes-key">{$Product.make}:</div>
					<div class="zes-value">{$Product.name}</div>
					<div class="zes-price">{Product.price($Product.price.base)}</div>
				</div>
				{#if $Product.price.extra}
					<div class="zes-group">
						<div class="zes-key">Extra:</div>
						<div class="zes-value">Opties en Diensten</div>
						<div class="zes-price">+ {Product.price($Product.price.extra)}</div>
					</div>
				{/if}
				<div class="zes-group">
					<div class="zes-key"></div>
					<div class="zes-value">Totaal</div>
					<div class="zes-price">{Product.price($Product.price.total)}</div>
				</div>
			</div>
		</div>

		<div class="zes-toolbar">
			{#if Product.getValid()}
				<div on:click="{event => basket()}" class="zes-button zes-button-large zes-success">Winkelmandje <i class="fa-light fa-circle-chevron-right"></i></div>
			{:else}
				<div class="zes-button zes-button-large zes-disabled">Winkelmandje <i class="fa-light fa-circle-chevron-right"></i></div>
			{/if}
		</div>
	</div>

	<div class="zes-specification">
		{#if $Product.steps}
			{#each $Product.steps as step}
				<div class="zes-step" class:zes-error="{(step.state === 'error')}">
					<div class="zes-number">
						<i class="fa-light fa-circle-{step.order}"></i>
					</div>
					<div class="zes-content">
						<div class="zes-title">{step.name}</div>

						{#each step.properties as property, index}
							{#if Product.menuVisibleProperty(property, step)}
								<div class="zes-group" class:zes-error="{(step.state === 'error') && !property.selected.valid}">
									<div class="zes-key">{Product.getPropertyName(property)}:</div>
									{#if property.selected.label}
										<div class="zes-edit" on:click="{event => edit(step, property)}">
											<i class="fa-light fa-pen-to-square"></i>
										</div>
										<div class="zes-value">
											{property.selected.label}
										</div>
										{#if property.selected.price}
											<div class="zes-price">+ {Product.price(property.selected.price)}</div>
										{/if}
									{:else}
										<div class="zes-edit" on:click="{event => edit(step, property)}">
											<i class="fa-light fa-square-question"></i>
										</div>
										<div class="zes-value">Onbekend</div>
									{/if}
								</div>
							{/if}
						{/each}
					</div>
				</div>
			{/each}
		{/if}
	</div>

	<div class="zes-quotation">
		<div class="zes-toolbar">
			{#if Product.getValid()}
				<div on:click="{event => basket()}" class="zes-button zes-button-large zes-success">Winkelmandje <i class="fa-light fa-circle-chevron-right"></i></div>
			{:else}
				<div class="zes-button zes-button-large zes-disabled">Winkelmandje <i class="fa-light fa-circle-chevron-right"></i></div>
			{/if}
		</div>
	</div>

	<div class="zes-images">
		<h4><i class="fa-light fa-circle-camera"></i> Voorbeeld</h4>
		{#if Gallery.main()}
			<img src="{Gallery.main().image}"/>
		{/if}
	</div>

	<div class="zes-quotation">
		<div class="zes-toolbar">
			{#if Product.getValid()}
				<div on:click="{event => basket()}" class="zes-button zes-button-large zes-success">Winkelmandje <i class="fa-light fa-circle-chevron-right"></i></div>
			{:else}
				<div class="zes-button zes-button-large zes-disabled">Winkelmandje <i class="fa-light fa-circle-chevron-right"></i></div>
			{/if}
		</div>
	</div>
{/if}